import {
	AppBar, Button, Divider, Drawer, Radio, RadioGroup, FormControlLabel,
	IconButton, List, makeStyles, Toolbar, FormControl,
	Typography, LinearProgress, TextField, Box, CircularProgress, Link
} from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import DashboardIcon from '@material-ui/icons/Dashboard';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import GroupIcon from '@material-ui/icons/Group';
import MenuIcon from "@material-ui/icons/Menu";
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import WarningIcon from '@material-ui/icons/Warning';
import clsx from "clsx";
import React, { useEffect, useState } from 'react';
import {
	BrowserView,
	isDesktop
} from "react-device-detect";
import { NavLink as RouterLink, Outlet } from 'react-router-dom';
import { useActions, useValues } from 'kea';
import { useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { keycloak } from '../../config/keycloak';
import SvgLogoWhite from '../../resources/icons/SvgLogoWhite';
import checkRole from '../../utils/checkRole';
import alertlogic from 'src/store/alert';
import vehiclelogic from 'src/store/vehicle';
import geofencelogic from 'src/store/geofence';
import grouplogic from 'src/store/group';
import { preferenceslogic } from 'src/store/global';
import organisationlogic from 'src/store/organisation';
import profilelogic from 'src/store/profile';
import {
	ralertlogic, rgeofencelogic, rmovementlogic, rnotificationlogic,
	rstationarylogic, rsummarylogic, rtemperaturelogic, rtrackerslogic,
	rbeaconmovementlogic, rkeylogic
} from 'src/store/report';
import rolelogic from 'src/store/role';
import userlogic from 'src/store/user';
import feedbacklogic from 'src/store/feedback';
import triplogic from 'src/store/trip';
import keylogic from 'src/store/key';

import Rating from '@material-ui/lab/Rating';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';

import AccountDisabled from '../../views/errors';
import assetlogic from 'src/store/asset';

const drawerWidth = isDesktop ? 220 : 0;
// console.log(drawerWidth)

//TODO clean styles
const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
	},
	toolbarDesktop: {
		paddingRight: 24, // keep right padding when drawer closed
	},
	toolbarMobile: {
		paddingRight: 16, // keep right padding when drawer closed
	},
	toolbarIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: "0 8px",
		// ...theme.mixins.toolbar,
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: 36,
	},
	menuButtonHidden: {
		display: "none",
	},
	title: {
		flexGrow: 1,
	},
	drawerPaper: {
		position: "fixed",
		whiteSpace: "nowrap",
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerPaperClose: {
		overflowX: "hidden",
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		width: theme.spacing(7),
		[theme.breakpoints.up("sm")]: {
			width: theme.spacing(9),
		},
	},
	// appBarSpacer: theme.mixins.toolbar,
	appBarSpacer: {
		minHeight: "48px",
		zIndex: "1299",
	},
	list: {
		padding: '0px',
	},
	paper: {
		padding: theme.spacing(0),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
	},
	fixedHeightTopRow: {
		height: 467,
	},
	fixedHeightBottomRow: {
		height: 400,
	},
	tableSearch: {
		'& > *': {
			margin: theme.spacing(1),
			width: '25ch',
		},
	},
	// leaflet_draw:{
	// 	height: "100%",
	// 	width: "100%",
	// 	margin: "0 auto",
	// },
	// floatpanel: {
	// 	top: 200,
	// 	left: 80,
	// 	zIndex: "1000",
	// 	position: "absolute",
	// height:467,
	// },
	content: {

		// minHeight: "48px",
		// backgroundColor:
		//   theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
		backgroundColor: theme.palette.grey[100],
		flexGrow: 1,
		// height: "100vh",
		// overflow: "auto",
	},
	outlet: {
		// marginLeft: theme.spacing(5),
		// position: "absolute",
		// top: 45,
		// left: 50,
		backgroundColor: theme.palette.grey[100],
		flexGrow: 1,
		height: "100%",
		width: "100%",
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	outletShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	outletUnshift: {
		marginLeft: isDesktop ? '72px' : '0px',
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		})
	},
}));

const DashboardLayout = () => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	const location = useLocation();

	const { submit } = useActions(feedbacklogic);
	const { loading: feedbackloading, error: feedbackerror, success: feedbacksuccess } = useValues(feedbacklogic);

	const { loading: triploading, error: triperror, success: tripsuccess } = useValues(triplogic);

	const { fetch } = useActions(profilelogic);
	const { profile, block_error } = useValues(profilelogic);

	const { setDrawer } = useActions(preferenceslogic);
	const { drawer } = useValues(preferenceslogic);


	const { loading: alertloading, error: alerterror, success: alertsuccess } = useValues(alertlogic);
	const { loading: vehicleloading, error: vehicleerror, success: vehiclesuccess } = useValues(vehiclelogic);
	const { loading: geofenceloading, error: geofenceerror, success: geofencesuccess } = useValues(geofencelogic);
	const { loading: grouploading, error: grouperror, success: groupsuccess } = useValues(grouplogic);
	const { loading: organisationloading, error: organisationerror, success: organisationsuccess } = useValues(organisationlogic);
	const { loading: profileloading, error: profileerror, success: profilesuccess } = useValues(profilelogic);
	const { loading: roleloading, error: roleerror, success: rolesuccess } = useValues(rolelogic);
	const { loading: userloading, error: usererror, success: usersuccess } = useValues(userlogic);
	const { loading: assetloading, error: asseterror, success: assetsuccess } = useValues(assetlogic);
	const { loading: keyloading, error: keyerror, success: keysuccess } = useValues(keylogic);


	//report logic
	const { loading: ralertloading, error: ralerterror, success: ralertsuccess } = useValues(ralertlogic);
	const { loading: rgeofenceloading, error: rgeofenceerror, success: rgeofencesuccess } = useValues(rgeofencelogic);
	const { loading: rignitionloading, error: rignitionerror, success: rignitionsuccess } = useValues(rmovementlogic);
	const { loading: rnotificationloading, error: rnotificationerror, success: rnotificationsuccess } = useValues(rnotificationlogic);
	const { loading: rstationaryloading, error: rstationaryerror, success: rstationarysuccess } = useValues(rstationarylogic);
	const { loading: rsummaryloading, error: rsummaryerror, success: rsummarysuccess } = useValues(rsummarylogic);
	const { loading: rtemperatureloading, error: rtemperatureerror, success: rtemperaturesuccess } = useValues(rtemperaturelogic);
	const { loading: rtrackersloading, error: rtrackerserror, success: rtrackerssuccess } = useValues(rtrackerslogic);
	const { loading: rbeaconmovementloading, error: rbeaconmovementerror, success: rbeaconmovementsuccess } = useValues(rbeaconmovementlogic);
	const { loading: rkeyloading, error: rkeyerror, success: rkeysuccess } = useValues(rkeylogic);

	const loading = keyloading || alertloading || vehicleloading || geofenceloading || grouploading ||
		organisationloading || profileloading || roleloading || userloading || ralertloading ||
		rgeofenceloading || rignitionloading || rnotificationloading || rstationaryloading ||
		rsummaryloading || rtemperatureloading || rtrackersloading || feedbackloading ||
		triploading || assetloading || rbeaconmovementloading || rkeyloading;


	useEffect(() => {
		if (keyerror) enqueueSnackbar(keyerror[0], { variant: 'error' })
	}, [keyerror])
	useEffect(() => {
		if (asseterror) enqueueSnackbar(asseterror[0], { variant: 'error' })
	}, [asseterror])

	useEffect(() => {
		if (alerterror) enqueueSnackbar(alerterror[0], { variant: 'error' })
	}, [alerterror])

	useEffect(() => {
		if (vehicleerror) enqueueSnackbar(vehicleerror[0], { variant: 'error' })
	}, [vehicleerror])

	useEffect(() => {
		if (geofenceerror) enqueueSnackbar(geofenceerror[0], { variant: 'error' })
	}, [geofenceerror])

	useEffect(() => {
		if (grouperror) enqueueSnackbar(grouperror[0], { variant: 'error' })
	}, [grouperror])

	useEffect(() => {
		if (organisationerror) enqueueSnackbar(organisationerror[0], { variant: 'error' })
	}, [organisationerror])

	useEffect(() => {
		if (profileerror) enqueueSnackbar(profileerror[0], { variant: 'error' })
	}, [profileerror])

	useEffect(() => {
		if (roleerror) enqueueSnackbar(roleerror[0], { variant: 'error' })
	}, [roleerror])

	useEffect(() => {
		if (usererror) enqueueSnackbar(usererror[0], { variant: 'error' })
	}, [usererror])



	useEffect(() => {
		if (rkeyerror) enqueueSnackbar(rkeyerror[0], { variant: 'error' })
	}, [rkeyerror])

	useEffect(() => {
		if (ralerterror) enqueueSnackbar(ralerterror[0], { variant: 'error' })
	}, [ralerterror])

	useEffect(() => {
		if (rgeofenceerror) enqueueSnackbar(rgeofenceerror[0], { variant: 'error' })
	}, [rgeofenceerror])

	useEffect(() => {
		if (rignitionerror) enqueueSnackbar(rignitionerror[0], { variant: 'error' })
	}, [rignitionerror])

	useEffect(() => {
		if (rnotificationerror) enqueueSnackbar(rnotificationerror[0], { variant: 'error' })
	}, [rnotificationerror])

	useEffect(() => {
		if (rstationaryerror) enqueueSnackbar(rstationaryerror[0], { variant: 'error' })
	}, [rstationaryerror])

	useEffect(() => {
		if (rsummaryerror) enqueueSnackbar(rsummaryerror[0], { variant: 'error' })
	}, [rsummaryerror])

	useEffect(() => {
		if (rtemperatureerror) enqueueSnackbar(rtemperatureerror[0], { variant: 'error' })
	}, [rtemperatureerror])

	useEffect(() => {
		if (rtemperatureerror) enqueueSnackbar(rtemperatureerror[0], { variant: 'error' })
	}, [rtemperatureerror])

	useEffect(() => {
		if (rtrackerserror) enqueueSnackbar(rtrackerserror[0], { variant: 'error' })
	}, [rtrackerserror])

	useEffect(() => {
		if (rbeaconmovementerror) enqueueSnackbar(rbeaconmovementerror[0], { variant: 'error' })
	}, [rbeaconmovementerror])

	useEffect(() => {
		if (feedbackerror) enqueueSnackbar(feedbackerror[0], { variant: 'error' })
	}, [feedbackerror])

	useEffect(() => {
		if (triperror) enqueueSnackbar(triperror[0], { variant: 'error' })
	}, [triperror])




	useEffect(() => {
		if (keysuccess) enqueueSnackbar(keysuccess[0], { variant: 'success' })
	}, [keysuccess])

	useEffect(() => {
		if (assetsuccess) enqueueSnackbar(assetsuccess[0], { variant: 'success' })
	}, [assetsuccess])

	useEffect(() => {
		if (alertsuccess) enqueueSnackbar(alertsuccess[0], { variant: 'success' })
	}, [alertsuccess])

	useEffect(() => {
		if (vehiclesuccess) enqueueSnackbar(vehiclesuccess[0], { variant: 'success' })
	}, [vehiclesuccess])

	useEffect(() => {
		if (geofencesuccess) enqueueSnackbar(geofencesuccess[0], { variant: 'success' })
	}, [geofencesuccess])

	useEffect(() => {
		if (groupsuccess) enqueueSnackbar(groupsuccess[0], { variant: 'success' })
	}, [groupsuccess])

	useEffect(() => {
		if (organisationsuccess) enqueueSnackbar(organisationsuccess[0], { variant: 'success' })
	}, [organisationsuccess])

	useEffect(() => {
		if (profilesuccess) enqueueSnackbar(profilesuccess[0], { variant: 'success' })
	}, [profilesuccess])

	useEffect(() => {
		if (rolesuccess) enqueueSnackbar(rolesuccess[0], { variant: 'success' })
	}, [rolesuccess])

	useEffect(() => {
		if (usersuccess) enqueueSnackbar(usersuccess[0], { variant: 'success' })
	}, [usersuccess])



	useEffect(() => {
		if (rkeysuccess) enqueueSnackbar(rkeysuccess[0], { variant: 'success' })
	}, [rkeysuccess])

	useEffect(() => {
		if (ralertsuccess) enqueueSnackbar(ralertsuccess[0], { variant: 'success' })
	}, [ralertsuccess])

	useEffect(() => {
		if (rgeofencesuccess) enqueueSnackbar(rgeofencesuccess[0], { variant: 'success' })
	}, [rgeofencesuccess])

	useEffect(() => {
		if (rignitionsuccess) enqueueSnackbar(rignitionsuccess[0], { variant: 'success' })
	}, [rignitionsuccess])

	useEffect(() => {
		if (rnotificationsuccess) enqueueSnackbar(rnotificationsuccess[0], { variant: 'success' })
	}, [rnotificationsuccess])

	useEffect(() => {
		if (rstationarysuccess) enqueueSnackbar(rstationarysuccess[0], { variant: 'success' })
	}, [rstationarysuccess])

	useEffect(() => {
		if (rsummarysuccess) enqueueSnackbar(rsummarysuccess[0], { variant: 'success' })
	}, [rsummarysuccess])

	useEffect(() => {
		if (rtemperaturesuccess) enqueueSnackbar(rtemperaturesuccess[0], { variant: 'success' })
	}, [rtemperaturesuccess])

	useEffect(() => {
		if (rtrackerssuccess) enqueueSnackbar(rtrackerssuccess[0], { variant: 'success' })
	}, [rtrackerssuccess])

	useEffect(() => {
		if (rbeaconmovementsuccess) enqueueSnackbar(rbeaconmovementsuccess[0], { variant: 'success' })
	}, [rbeaconmovementsuccess])

	useEffect(() => {
		if (feedbacksuccess) enqueueSnackbar(feedbacksuccess[0], { variant: 'success' })
	}, [feedbacksuccess])

	useEffect(() => {
		if (tripsuccess) enqueueSnackbar(tripsuccess[0], { variant: 'success' })
	}, [tripsuccess])


	useEffect(() => {
		profile ?? fetch()
	}, []) // eslint-disable-line

	const [feedbackOpen, setFeedbackOpen] = useState(false);
	const [feedback, setFeedback] = useState({ rating: 3, category: 'problem', body: '' });

	const setLogout = () => {
		keycloak.logout();
	}

	const toggleDrawer = () => {
		setDrawer({ expand: !drawer.expand });
	};

	const handleSubmit = () => {
		// console.log(feedback)
		window.smartlook('track', 'UserSubmittedFeedback')
		handleClose();
		submit(feedback);
		setFeedback({ rating: 3, category: 'problem', body: '' });
	}

	const handleClose = () => {
		setFeedbackOpen(false);
	}

	const handleOpen = () => {
		setFeedbackOpen(true);
	}

	if (block_error) {
		return <AccountDisabled error={block_error} />
	}
	if (!profile) {
		return <div style={{ top: '20px', display: 'flex', justifyContent: 'center' }}>
			<CircularProgress />
		</div>
	}
	if (window.smartlook) window.smartlook('identify', profile._id);

	const customIcons = {
		1: {
			icon: <SentimentVeryDissatisfiedIcon />,
			label: 'Very Dissatisfied',
		},
		2: {
			icon: <SentimentDissatisfiedIcon />,
			label: 'Dissatisfied',
		},
		3: {
			icon: <SentimentSatisfiedIcon />,
			label: 'Neutral',
		},
		4: {
			icon: <SentimentSatisfiedAltIcon />,
			label: 'Satisfied',
		},
		5: {
			icon: <SentimentVerySatisfiedIcon />,
			label: 'Very Satisfied',
		},
	};

	const IconContainer = (props) => {
		const { value, ...other } = props;
		return <span {...other}>{customIcons[value].icon}</span>;
	}

	return (
		<div className={classes.root}>
			<div>
				<Dialog
					open={feedbackOpen}
					onClose={handleClose}
					aria-labelledby="form-dialog-title"
				>
					<DialogTitle id="form-dialog-title">
						We would like your feedback to improve our website.
					</DialogTitle>
					<DialogContent>
						{/* <Box component="fieldset" mb={3} borderColor="transparent">
							<Typography component="legend">What is your opinion of this website?</Typography>
							<Rating
								name="customized-icons"
								defaultValue={2}
								value={feedback.rating}
								onChange={(e) => setFeedback({ ...feedback, rating: e.target.value })}
								getLabelText={(value) => customIcons[value].label}
								IconContainerComponent={IconContainer}
							/>
						</Box> */}
						<FormControl component="fieldset">
							<Typography component="legend">
								Please select your feedback category.
							</Typography>
							<RadioGroup aria-label="category" name="category" value={feedback.category} onChange={(e) => setFeedback({ ...feedback, category: e.target.value })}>
								<FormControlLabel value="suggestion" control={<Radio />} label="Suggestion" />
								<FormControlLabel value="problem" control={<Radio />} label="Problem" />
								{/* <FormControlLabel value="compliment" control={<Radio />} label="Compliment" /> */}
							</RadioGroup>
						</FormControl>
						<Box component="fieldset" mb={3} borderColor="transparent" paddingTop='15px'>
							<TextField
								id="outlined-multiline-static"
								label="Please leave your feedback here"
								multiline
								rows={6}
								fullWidth
								value={feedback.body}
								onChange={(e) => setFeedback({ ...feedback, body: e.target.value })}
								variant="outlined"
							/>
						</Box>
						<div style={{ textAlign: 'center' }}>
							<Button type={'submit'} color="primary" onClick={handleSubmit}>
								Submit
							</Button>
						</div>
					</DialogContent>
					<DialogActions>
					</DialogActions>
				</Dialog>
			</div>
			<AppBar
				position="fixed"
				className={clsx(classes.appBar, drawer.expand && classes.appBarShift)}
			>
				<Toolbar className={classes.toolbarDesktop} variant="dense">
					<BrowserView>
						<IconButton
							edge="start"
							color="inherit"
							aria-label="open drawer"
							onClick={toggleDrawer}
							className={clsx(
								classes.menuButton,
								drawer.expand && classes.menuButtonHidden
							)}
						>
							<MenuIcon />
						</IconButton>
					</BrowserView>
					<Typography
						component="h1"
						variant="h6"
						color="inherit"
						noWrap
						className={classes.title}
					>
						<div
							style={{
								paddingTop: '5px'
							}}
						>
							<RouterLink to="/">
								<SvgLogoWhite />
							</RouterLink>
						</div>
					</Typography>
					<Tooltip title="Click here to report a problem or make a suggestion">
						<Button
							color="inherit"
							style={{
								left: '10px'
							}}
							onClick={handleOpen}
							startIcon={<ReportProblemIcon />}
						// endIcon={<ReportProblemIcon />}
						>
							Report
						</Button>
					</Tooltip>
					<Tooltip title="Logout">
						<Button
							color="inherit"
							style={{
								left: '10px'
							}}
							onClick={setLogout}
							startIcon={<ExitToAppIcon />}
						>Logout</Button>
					</Tooltip>
				</Toolbar>
			</AppBar>
			<BrowserView>
				<Drawer
					variant="permanent"
					classes={{
						paper: clsx(classes.drawerPaper, !drawer.expand && classes.drawerPaperClose),
					}}
					open={drawer.expand}
				>
					<div className={classes.toolbarIcon}>
						<IconButton onClick={toggleDrawer}>
							<ChevronLeftIcon />
						</IconButton>
					</div>
					<Divider />
					<List>
						<ListItem
							button
							component={RouterLink}
							to={'/app/dashboard'}
							style={{ borderRight: location.pathname.localeCompare('/app/dashboard') === 0 ? '3px solid #3f51b5' : null }}
						>
							<ListItemIcon>
								<DashboardIcon
									htmlColor={location.pathname.localeCompare('/app/dashboard') === 0 ? '#3f51b5' : null}
								/>
							</ListItemIcon>
							<ListItemText primary="Dashboard" />
						</ListItem>
						{
							checkRole(profile, ['AssetView', 'AssetEdit'])
								?
								<ListItem
									button
									component={RouterLink}
									to={'/app/assets'}
									style={{ borderRight: location.pathname.localeCompare('/app/assets') === 0 ? '3px solid #3f51b5' : null }}
								>
									<ListItemIcon>
										<SettingsRemoteIcon
											htmlColor={location.pathname.localeCompare('/app/assets') === 0 ? '#3f51b5' : null}
										/>
									</ListItemIcon>
									<ListItemText primary="Assets" />
								</ListItem>
								:
								null
						}
						{
							checkRole(profile, ['VehicleView', 'VehicleEdit'])
								?
								<ListItem
									button
									component={RouterLink}
									to={'/app/vehicles'}
									style={{ borderRight: location.pathname.localeCompare('/app/vehicles') === 0 ? '3px solid #3f51b5' : null }}
								>
									<ListItemIcon>
										<DirectionsCarIcon
											htmlColor={location.pathname.localeCompare('/app/vehicles') === 0 ? '#3f51b5' : null}
										/>
									</ListItemIcon>
									<ListItemText primary="Vehicles" />
								</ListItem>
								:
								null
						}
						{
							checkRole(profile, ['GeofenceEdit', 'GeofenceView'])
								?
								<ListItem
									button
									component={RouterLink}
									to={'/app/geofence'}
									style={{ borderRight: location.pathname.localeCompare('/app/geofence') === 0 ? '3px solid #3f51b5' : null }}
								>
									<ListItemIcon>
										<CheckBoxOutlineBlankIcon
											htmlColor={location.pathname.localeCompare('/app/geofence') === 0 ? '#3f51b5' : null}
										/>
									</ListItemIcon>
									<ListItemText primary="Geofences" />
								</ListItem>
								:
								null
						}
						{
							checkRole(profile, ['AlertEdit', 'AlertView'])
								?
								<ListItem
									button
									component={RouterLink}
									style={{ borderRight: location.pathname.localeCompare('/app/alerts') === 0 ? '3px solid #3f51b5' : null }}
									to={'/app/alerts'}>
									<ListItemIcon>
										<WarningIcon
											htmlColor={location.pathname.localeCompare('/app/alerts') === 0 ? '#3f51b5' : null} />
									</ListItemIcon>
									<ListItemText primary="Alerts" />
								</ListItem>
								:
								null
						}
					</List>
					{checkRole(profile, ['Admin']) &&
						<>
							<Divider />
							<List>
								<ListItem
									button
									component={RouterLink}
									style={{ borderRight: location.pathname.localeCompare('/app/groups') === 0 ? '3px solid #3f51b5' : null }}
									to={'/app/groups'}>
									<ListItemIcon>
										<GroupIcon
											htmlColor={location.pathname.localeCompare('/app/groups') === 0 ? '#3f51b5' : null} />
									</ListItemIcon>
									<ListItemText primary="Groups" />
								</ListItem>
								<ListItem
									button
									component={RouterLink}
									style={{ borderRight: location.pathname.localeCompare('/app/users') === 0 ? '3px solid #3f51b5' : null }}
									to={'/app/users'}>
									<ListItemIcon>
										<RecentActorsIcon
											htmlColor={location.pathname.localeCompare('/app/users') === 0 ? '#3f51b5' : null} />
									</ListItemIcon>
									<ListItemText primary="User Management" />
								</ListItem>
							</List>
						</>
					}
					{checkRole(profile, ['Reports']) &&
						<>
							<Divider />
							<List>
								<ListItem
									button
									component={RouterLink}
									style={{ borderRight: location.pathname.localeCompare('/app/reports') === 0 ? '3px solid #3f51b5' : null }}
									to={'/app/reports'}>
									<ListItemIcon>
										<AssignmentIcon
											htmlColor={location.pathname.localeCompare('/app/reports') === 0 ? '#3f51b5' : null} />
									</ListItemIcon>
									<ListItemText primary="Reports" />
								</ListItem>
							</List>
						</>
					}
					<Divider />
					<List>
						<ListItem button
							component={RouterLink}
							to={'/app/account'}
							style={{ borderRight: location.pathname.localeCompare('/app/account') === 0 ? '3px solid #3f51b5' : null }}
						>
							<ListItemIcon>
								<AccountBoxIcon
									htmlColor={location.pathname.localeCompare('/app/account') === 0 ? '#3f51b5' : null} />
							</ListItemIcon>
							<ListItemText primary="Account" />
						</ListItem>
					</List>
					<List>
						<Link
							style={{
								paddingRight: '30px',
								display: 'flex',
							}}
							target="_blank"
							href="https://wiki.trakngo.com.au"
						>
							<ListItem
								hover
							// style={{ borderRight: location.pathname.localeCompare('/app/account') === 0 ? '3px solid #3f51b5' : null }}
							>
								<ListItemIcon>
									<OpenInNewIcon
									// htmlColor={location.pathname.localeCompare('/app/account') === 0 ? '#3f51b5' : null}
									/>
								</ListItemIcon>
								<ListItemText primary="Help/Wiki" />
							</ListItem>
						</Link>
					</List>
				</Drawer>
			</BrowserView>
			<main className={clsx(classes.outlet, drawer.expand && classes.outletShift, !drawer.expand && classes.outletUnshift)}>
				<div className={classes.appBarSpacer} />
				{loading && <LinearProgress style={{ position: 'fixed', top: '48px', width: '100%', zIndex: '1199' }} />}
				<div id="OutletContainer">
					<Outlet />
				</div>
			</main>
		</div >
	);
};

export default DashboardLayout;
